import { useEffect, useState } from "react";
import { CitySearchDropdown } from "./Search/CitySearchDropdown";
import { CountrySearchDropdown } from "./Search/CountrySearchDropdown";
import { StateSearchDropdown } from "./Search/StateSearchDropdown";

export default function LocationBasic({
  onLocationChange,
  country,
  state,
  city,
}) {
  const [countryValue, setCountryValue] = useState();
  const [stateValue, setStateValue] = useState();
  const [countryId, setCountryId] = useState();
  const [stateId, setStateId] = useState();
  const [cityValue, setCityValue] = useState();

  useEffect(() => {
    setCountryValue(country);
    setCityValue(city);
    setStateValue(state);
  }, [country, state, city]);

  const onSearchLocationChange = (val, key) => {
    if (key === "country") {
      setCountryValue(val?.name);
      setCountryId(val?.numeric_code);
      onLocationChange(key, val?.name);
      setStateValue();
      setStateId();
      setCityValue();
    }
    if (key === "state") {
      setStateValue(val?.name);
      setStateId(val?.id);
      setCityValue();
      onLocationChange(key, val?.name);
    }
    if (key === "city") {
      setCityValue(val?.name);
      onLocationChange(key, val?.name);
    }
  };

  return (
    <div className="row">
      <div className="col-md-4">
        <p className="form-label">
          <span className="text-danger">* </span>Country
        </p>
        <CountrySearchDropdown
          searchStyle={{ width: "100%" }}
          placeholder="Country"
          onSearchSelect={(e) => onSearchLocationChange(e, "country")}
          defaultCountryValue={countryValue}
        />
      </div>
      <div className="col-md-4">
        <p className="form-label">
          <span className="text-danger">* </span>State
        </p>
        <StateSearchDropdown
          searchStyle={{ width: "100%" }}
          placeholder="State"
          onSearchSelect={(e) => onSearchLocationChange(e, "state")}
          countryKey={countryId}
          defaultStateValue={stateValue}
          className="form-control"
        />
      </div>
      <div className="col-md-4">
        <p className="form-label">
          <span className="text-danger">* </span>City
        </p>
        <CitySearchDropdown
          searchStyle={{ width: "100%" }}
          placeholder="City"
          onSearchSelect={(e) => onSearchLocationChange(e, "city")}
          stateKey={stateId}
          defaultCityValue={cityValue}
          className="form-control"
        />
      </div>
    </div>
  );
}
